import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useOnce } from '@root/src/web/lib/useOnce';
import { getLocaleCode } from '@root/src/web/lib/getCountryCode';
import { getCookie } from '@guardian/libs';
import { pickMessage, } from '@root/src/web/lib/messagePicker';
import { ReaderRevenueEpic, canShowReaderRevenueEpic, } from './ReaderRevenueEpic';
import { MaybeBrazeEpic, canShowBrazeEpic } from './BrazeEpic';
const buildReaderRevenueEpicConfig = (canShowData) => {
    return {
        candidate: {
            id: 'reader-revenue-banner',
            canShow: () => canShowReaderRevenueEpic(canShowData),
            show: (meta) => () => {
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                return _jsx(ReaderRevenueEpic, Object.assign({}, meta), void 0);
            },
        },
        timeoutMillis: null,
    };
};
const buildBrazeEpicConfig = (brazeMessages, countryCode, idApiUrl, brazeArticleContext) => {
    return {
        candidate: {
            id: 'braze-epic',
            canShow: () => canShowBrazeEpic(brazeMessages, brazeArticleContext),
            show: (meta) => () => (_jsx(MaybeBrazeEpic, { meta: meta, countryCode: countryCode, idApiUrl: idApiUrl }, void 0)),
        },
        timeoutMillis: 2000,
    };
};
export const SlotBodyEnd = ({ contentType, sectionName, sectionId, shouldHideReaderRevenue, isMinuteArticle, isPaidContent, tags, contributionsServiceUrl, brazeMessages, idApiUrl, stage, asyncArticleCount, }) => {
    const [countryCode, setCountryCode] = useState();
    const isSignedIn = !!getCookie({ name: 'GU_U', shouldMemoize: true });
    const browserId = getCookie({ name: 'bwid', shouldMemoize: true });
    const [SelectedEpic, setSelectedEpic] = useState(null);
    useEffect(() => {
        const callFetch = () => {
            getLocaleCode()
                .then((cc) => {
                setCountryCode(cc || '');
            })
                .catch((e) => console.error(`countryCodePromise - error: ${e}`));
        };
        callFetch();
    }, []);
    useOnce(() => {
        const readerRevenueEpic = buildReaderRevenueEpicConfig({
            isSignedIn,
            countryCode,
            contentType,
            sectionId,
            shouldHideReaderRevenue,
            isMinuteArticle,
            isPaidContent,
            tags,
            contributionsServiceUrl,
            idApiUrl,
            stage,
            asyncArticleCount: asyncArticleCount,
            browserId: browserId || undefined,
        });
        const brazeArticleContext = {
            section: sectionName,
        };
        const brazeEpic = buildBrazeEpicConfig(brazeMessages, countryCode, idApiUrl, brazeArticleContext);
        const epicConfig = {
            candidates: [brazeEpic, readerRevenueEpic],
            name: 'slotBodyEnd',
        };
        pickMessage(epicConfig)
            .then((PickedEpic) => setSelectedEpic(PickedEpic))
            .catch((e) => console.error(`SlotBodyEnd pickMessage - error: ${e}`));
    }, [isSignedIn, countryCode, brazeMessages, asyncArticleCount]);
    if (SelectedEpic) {
        return _jsx(SelectedEpic, {}, void 0);
    }
    return null;
};
